
import './App.css';
import About from './Components/About';
import Contact from './Components/Contact';
import Blogs from './Components/Blogs';

import { FloatingWhatsApp } from 'react-floating-whatsapp'

import Navbar from './Components/Navbar';
import Products from './Components/Products';
import Footer from './Footer';

import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

function App() {

  return (
    
    <>
    <FloatingWhatsApp 
      accountName="Noble Edge Trading LLC"
      onClick={function noRefCheck(){}}
      onClose={function noRefCheck(){}}
      onLoopDone={function noRefCheck(){}}
      onNotification={function noRefCheck(){}}
      onSubmit={function noRefCheck(){}}
      phoneNumber="+971523964280"
      statusMessage="Typically replies within minutes"
      

    />
<BrowserRouter>
 <Navbar title='Noble Edge Trading'/>
 <Routes>
<Route path='/' element={<Products/> }>
  

</Route>


<Route path='/about' element={ <About/>}/>
<Route path='/contactUs' element={ <Contact/>}/>
<Route path='/blogs' element={ <Blogs/>}/>

 

 </Routes>

 <Footer/>
</BrowserRouter>
    </>
  );
}

export default App;
